<script setup lang="ts">
import { storeToRefs } from "pinia";

import NavHeader from "@/components/general/NavHeader.vue";
import { appStore } from "@/stores/AppStore";

const store = appStore();
const { bgColor } = storeToRefs(store);

const autoSignIn = async (): Promise<void> => {
  await store.autoSignIn("palletChecker");
};

autoSignIn();
</script>

<template>
  <div
    class="safe-area-bot min-h-screen flex flex-col"
    :style="{ backgroundColor: bgColor ?? 'var(--color-neutral-800)' }"
  >
    <NavHeader app-name="palletChecker" title="Kontrola palet" />
    <div class="flex flex-col flex-auto px-4 lg:px-8 py-6">
      <router-view />
      <DynamicDialog />
      <Toast />
    </div>
  </div>
</template>
